import PageGutter from './PageGutter.client'

export default PageGutter
